import React, { useEffect, useState } from "react";
import Header from "../layout/Header";
import { useForm } from "react-hook-form";
import { fetchAPI } from "../service/Encrtyption";
import { useNavigate ,useParams} from "react-router-dom";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { useDispatch, useSelector } from "react-redux";
import { login, registerData } from "./redux/store";
import { useTranslation } from "react-i18next";
import { Loader } from "../loader";
import ReactGA from 'react-ga4';

export const Register = () => {
  const { t, i18n } = useTranslation();
  const { lang } = useParams();

  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
  } = useForm();
  const REACT_APP_MAPS_API_KEY ="AIzaSyDSnvnrNEsJaOdNyzcOkLfjomZ8WVLiajw&libraries=places&callback";
  const [latitude, setLatitude] = useState(0);
  const [longitude, setLongitude] = useState(0);
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState("");
 const [lastsValue, setLastsValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  // const registration = useSelector((state) => state.registration);

 
  const mobileNumber = sessionStorage.getItem('mbn');

  //console.log("MBMB"+mobileNumber);
 
 
  const [formData, setFormData] = useState({
    cepFlag: false,
    countryId: 5,
    customerType: "Farmer",
    deviceId: "",
    deviceToken: "",
    firstName: "",
    geolocation: "",
    languageId: "1",
    lastName: "",
    mobileNumber: mobileNumber,
    optInWhatsApp: false,
    pincode: "",
    referrer: "",
    rhrdFlag: false,
    villageLocation: "",
    wheatProgramFlag: false,
    destinationURL: "/customer/registerCustomer",
  });

  const getCurrentLocation = () => {
    
    debugger; 
    setLoading(true)
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          setLatitude(latitude);
          setLongitude(longitude);
          const lats = `${latitude}, ${longitude}`;
          setLastsValue(lats);
          getAddressFromLatLng(latitude, longitude); 
          setLoading(false);
        },
        (error) => {
          console.error("Error getting location:", error);
          if (error) {
            alert("user denied maps");
            navigate(`/${lang}/login`); 
          }
        }
      );
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  };

  useEffect(() => {
    // window.addEventListener("load", () => {
    //   alert("Please allow location access to get your current location.");
    getCurrentLocation();
    // });
  }, []);

 
  const onSubmit = async () => {

    setLoading(true);
    ReactGA.event({
      category: 'User Register',
      action: 'CLK_REGISTER_BTN'
    });

    //debugger;
     try {
      const responseData = await fetchAPI(
        process.env.REACT_APP_API_URL,
        formData,
        {
          authKey: "",
          methodName: "",
          sharedWith: "",
        }
      );
     // console.log("jsonReposneDataOBJ"+JSON.stringify(formData));
      const jsonReposneData = JSON.parse(responseData);
     // console.log("jsonReposneData"+JSON.stringify(jsonReposneData));
      if (jsonReposneData.statusCode == 200 && jsonReposneData.otp) { 
        dispatch(login(jsonReposneData));
        navigate(`/${lang}/login`); 
      }else{
        setErrorMessage(jsonReposneData.message);
      }
     } catch (error) {
      console.error("Error fetching API:", error);
      setErrorMessage(error);
    } finally {
      setLoading(false);
    }
  };

  const getAddressFromLatLng = (lat, lng) => {
    if (window.google && window.google.maps) {
      const geocoder = new window.google.maps.Geocoder();
      const latLng = new window.google.maps.LatLng(lat, lng);
      geocoder.geocode({ location: latLng }, (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            setAddress(results[0].formatted_address);
           } else {
            console.log("No results found");
          }
        } else {
          console.log("Geocoder failed due to: " + status);
        }
      });
    } else {
      console.log("Google Maps API is not available.");
    }
  };

 

  const handleChange = (fieldName, value) => {
    setFormData((prevCrop) => ({
      ...prevCrop,
      [fieldName]: value, 
      villageLocation: address,
      geolocation: lastsValue 
    }));
    clearErrors(fieldName);
  };

  const handleKeyPress = (e) => {
    // debugger;
    // Get the keyCode of the pressed key
    const keyCode = e.keyCode || e.which;

    // Allow alphanumeric characters (a-z, A-Z, 0-9) and spaces (keyCode 32)
    const isAlphanumeric = (keyCode >= 65 && keyCode <= 90) || // A-Z
                           (keyCode >= 97 && keyCode <= 122) || // a-z
                           (keyCode >= 48 && keyCode <= 57) || // 0-9
                           keyCode === 32; // Space

    // If the pressed key is not alphanumeric or space, prevent default behavior
    if (!isAlphanumeric) {
      e.preventDefault();
    }
  };

  const hide = () => {
    setErrorMessage(""); // Assuming you have a state to manage the error message
  };
 
  return (
    <>
      <Header />

      <div className="main">
        <div className="container p-0">
          {loading && <Loader />}
          <div className="card border-0">
            <div className="card-body px-2 pt-0 pb-2">
              <div className="container">
                <form
                  onSubmit={handleSubmit(onSubmit)}
                  id="strongarmRegister-form"
                >
                  <div className="row">
                    <div className="col-6 pr-1">
                      <div className="form-group">
                        <label htmlFor="firstName">{t("firstName")}</label>
                        <input
                          type="text"
                          className={`form-control shadow mb-1 ${
                            errors.firstName ? "is-invalid" : ""
                          }`}
                          {...register("firstName", {
                            required: t("firstNameErrorMsg"),
                          })}
                          id="firstName"
                          autoComplete="off"
                          onChange={(e) =>
                            handleChange("firstName", e.target.value)
                          }
                          onKeyPress={handleKeyPress}
                        />
                        {errors.firstName && (
                          <div className="invalid-feedback">
                            {errors.firstName.message}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-6 pl-1">
                      <div className="form-group">
                        <label htmlFor="text"> {t("lastName")}</label>
                        <input
                          type="text"
                          className={`form-control  mb-1 shadow ${
                            errors.lastName ? "is-invalid" : ""
                          }`}
                          name="lastName"
                          id="lastName"
                          autoComplete="off"
                          {...register("lastName", {
                            required: t("lastNameErrorMsg"),
                          })}
                          onChange={(e) =>
                            handleChange("lastName", e.target.value)
                          }
                          onKeyPress={handleKeyPress}
                        />
                        {errors.lastName && (
                          <div className="invalid-feedback">
                            {errors.lastName.message}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="text"> {t("pincode")}</label>
                        <input
                          type="number"
                          className="form-control shadow"
                          name="pincode"
                          id="pincode"
                          autoComplete="off" 
                          maxLength={6}
                          onChange={(e) =>
                            handleChange("pincode", e.target.value)
                          }
                          onKeyDown={(e) => {
                            if (e.target.value.length  >= 6 && e.keyCode !== 8) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>
                    </div>

                    {/* Add similar input fields for other form fields */}

                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="locationInput"> {t("address")}</label>
                        <input
                          type="text"
                          className="form-control shadow"
                          {...register("location")}
                          id="locationInput"
                          autoComplete="off"
                          readOnly
                          value={address} // Display the address
                        />
                        <i className="fa fa-map-marker mapIcon"></i>
                      </div>
                    </div>
                  </div>
                  <div id="map" style={{ height: "495px", width: "100%" }}>
                    <LoadScript googleMapsApiKey={REACT_APP_MAPS_API_KEY}>
                      <GoogleMap
                        mapContainerStyle={{ height: "100%", width: "100%" }}
                        center={{ lat: latitude, lng: longitude }}
                        zoom={16}
                      >
                        <Marker
                          position={{ lat: latitude, lng: longitude }}
                          draggable={true} // Make the marker draggable
                          onDragEnd={(event) => {
                            const lat = event.latLng.lat();
                            const lng = event.latLng.lng();
                            setLatitude(lat);
                            setLongitude(lng);
                            getAddressFromLatLng(lat, lng);
                          }}
                        />
                      </GoogleMap>
                    </LoadScript>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary w-100 py-3 center-textbtn mt-3 text-white text-uppercase registerSubmitBtn"
                    id="submitBtn"
                  >
                    {t("done")}
                  </button>
                </form>
              </div>
              {errorMessage && (
                        <div
                          className="alert alert-warning alert-dismissible fade show mt-2"
                          role="alert"
                        >
                          {errorMessage}
                          <button
                            type="button"
                            className="close"
                            onClick={hide} 
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                      )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Register;
